var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "plans" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-map" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("plans.titles.manager")))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: { height: "calc(100vh - 78px - 100px)" },
        },
        [
          _c("LoadingMini", { ref: "loading" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-4 full-height" },
            [
              _c(
                "UiCard",
                {
                  staticClass: "full-height",
                  staticStyle: { overflow: "auto" },
                },
                [
                  _c("tree", {
                    ref: "tree",
                    attrs: {
                      treeData: _vm.treeData,
                      options: _vm.options,
                      icons: _vm.icons,
                      selected: _vm.externalSelected,
                      root: _vm.rootNode,
                    },
                    on: {
                      treeNodeClick: _vm.handleNode,
                      treeNodeRightClick: _vm.handleRightClick,
                      endDrag: _vm.handleSort,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-8 full-height" },
            [
              _c(
                "UiCard",
                {
                  staticClass: "full-height relative",
                  staticStyle: { padding: "0 !important", overflow: "hidden" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "plans-logo" },
                    [_c("UiBrandLogoWide")],
                    1
                  ),
                  _vm._v(" "),
                  _c("OutdoorMap", {
                    ref: "map",
                    class: [
                      { show: _vm.mapMode == 1 },
                      { drawing: _vm.isDrawing },
                    ],
                    attrs: { center: _vm.center, zoom: _vm.zoom },
                    on: {
                      loaded: _vm.onMapLoaded,
                      groupDrawn: _vm.groupDrawn,
                      groupEdited: _vm.groupEdited,
                    },
                  }),
                  _vm._v(" "),
                  _c("IndoorMap", {
                    key: _vm.selectedNode ? _vm.selectedNode.id : "root",
                    ref: "indoorMap",
                    class: { show: _vm.mapMode == 2 },
                    attrs: { plan: _vm.plan },
                  }),
                  _vm._v(" "),
                  _vm.isDrawing
                    ? _c("div", { staticClass: "helper" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("ap.drawingHelper")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Toolbar",
        [
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-add-plans",
                  expression: "'beepiz-add-plans'",
                },
              ],
              class: [{ "no-hover": _vm.showActions.add }, "default"],
              attrs: { disabled: !_vm.addIsActive },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleActions("add")
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-caret-up" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("global.add")))]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.closeAddActions,
                      expression: "closeAddActions",
                    },
                  ],
                  staticClass: "button-actions",
                  class: { show: _vm.showActions.add },
                  attrs: { slot: "actions" },
                  slot: "actions",
                },
                [
                  _c("ul", [
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.plan },
                        on: {
                          click: function ($event) {
                            return _vm.showModal("add", "plan")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-map fa-fw" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("plans.btns.addActions.plan")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.service },
                        on: {
                          click: function ($event) {
                            return _vm.showModal("add", "service")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "beepiz-folder" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("plans.btns.addActions.service")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.floor },
                        on: {
                          click: function ($event) {
                            return _vm.showModal("add", "floor")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "beepiz-stairs fa-fw" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("plans.btns.addActions.floor")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.building },
                        on: {
                          click: function ($event) {
                            return _vm.showModal("add", "building")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-building fa-fw" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("plans.btns.addActions.building")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.group },
                        on: {
                          click: function ($event) {
                            return _vm.showModal("add", "group")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "beepiz-plan-group fa-fw" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("plans.btns.addActions.group")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: { disabled: !_vm.rulesForAdd.site },
                        on: {
                          click: function ($event) {
                            return _vm.showModal("add", "site")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-globe fa-fw" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("plans.btns.addActions.site")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-plans || beepiz-delete-plans",
                  expression: "'beepiz-edit-plans || beepiz-delete-plans'",
                },
              ],
              class: [{ "no-hover": _vm.showActions.options }, "default"],
              attrs: { disabled: _vm.isRoot },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleActions("options")
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.closeOptionsActions,
                      expression: "closeOptionsActions",
                    },
                  ],
                  staticClass: "button-actions",
                  class: { show: _vm.showActions.options },
                },
                [
                  _c("ul", [
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "can",
                            rawName: "v-can",
                            value: "beepiz-delete-plans",
                            expression: "'beepiz-delete-plans'",
                          },
                        ],
                        class: {
                          disabled: !_vm.selectedNode || !_vm.isDeletable,
                        },
                        on: { click: _vm.handleDeleteAction },
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash fa-fw" }),
                        _vm._v(
                          " " + _vm._s(_vm.$t("global.delete")) + "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "can",
                            rawName: "v-can",
                            value: "beepiz-edit-plans",
                            expression: "'beepiz-edit-plans'",
                          },
                        ],
                        class: {
                          disabled:
                            !_vm.selectedNode ||
                            _vm.selectedNode.id == _vm.rootNode.id,
                        },
                        on: { click: _vm.handleEditAction },
                      },
                      [
                        _c("i", { staticClass: "fa fa-pencil fa-fw" }),
                        _vm._v(
                          " " + _vm._s(_vm.$t("global.edit")) + "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-caret-up" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("global.options")))]),
            ]
          ),
          _vm._v(" "),
          _vm.useDvFlagAccess("beepiz-manage-plan-can:update")
            ? _c(
                "Btn",
                { class: ["primary pull-right", { hide: _vm.isNotAPable }] },
                [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.routeAPManager, tag: "div" } },
                    [
                      _c("i", { staticClass: "fa fa-map-marker" }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("plans.btns.APManager"))),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("Modal", { ref: "modalAddSite", attrs: { width: "800px" } }, [
        _c("span", {
          attrs: { slot: "header" },
          domProps: { innerHTML: _vm._s(_vm.$t("plans.titles.add.site")) },
          slot: "header",
        }),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "content" }, slot: "content" },
          [
            _c("ModalSite", {
              ref: "modalAddSiteForm",
              on: {
                addSite: _vm.handleAddSite,
                editSite: _vm.handleEditSite,
                close: _vm.handleClose,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "modalAddBuilding", attrs: { width: "800px" } }, [
        _c("span", {
          attrs: { slot: "header" },
          domProps: { innerHTML: _vm._s(_vm.$t("plans.titles.add.building")) },
          slot: "header",
        }),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "content" }, slot: "content" },
          [
            _c("ModalBuilding", {
              ref: "modalAddBuildingForm",
              attrs: { site: _vm.selectedNode },
              on: {
                addBuilding: _vm.handleAddBuilding,
                editBuilding: _vm.handleEditBuilding,
                close: _vm.handleClose,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "modalAddGroup", attrs: { width: "400px" } }, [
        _c("span", {
          attrs: { slot: "header" },
          domProps: { innerHTML: _vm._s(_vm.$t("plans.titles.add.group")) },
          slot: "header",
        }),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "content" }, slot: "content" },
          [
            _c("ModalGroup", {
              ref: "modalAddGroupForm",
              attrs: { site: _vm.selectedNode },
              on: {
                addGroup: _vm.drawGroup,
                editGroup: _vm.handleEditGroup,
                close: _vm.handleClose,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "modalAddFloor", attrs: { width: "400px" } }, [
        _c("span", {
          attrs: { slot: "header" },
          domProps: { innerHTML: _vm._s(_vm.$t("plans.titles.add.floor")) },
          slot: "header",
        }),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "content" }, slot: "content" },
          [
            _c("ModalFloor", {
              ref: "modalAddFloorForm",
              attrs: { site: _vm.selectedNode },
              on: {
                addFloor: _vm.handleAddFloor,
                editFloor: _vm.handleEditFloor,
                close: _vm.handleClose,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "modalAddService", attrs: { width: "400px" } }, [
        _c("span", {
          attrs: { slot: "header" },
          domProps: { innerHTML: _vm._s(_vm.$t("plans.titles.add.service")) },
          slot: "header",
        }),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "content" }, slot: "content" },
          [
            _c("ModalService", {
              ref: "modalAddServiceForm",
              attrs: { site: _vm.selectedNode },
              on: {
                addService: _vm.handleAddService,
                editService: _vm.handleEditService,
                close: _vm.handleClose,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "modalAddPlan", attrs: { width: "400px", height: "100%" } },
        [
          _c("span", {
            attrs: { slot: "header" },
            domProps: { innerHTML: _vm._s(_vm.$t("plans.titles.add.plan")) },
            slot: "header",
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("ModalPlan", {
                ref: "modalAddPlanForm",
                attrs: { site: _vm.selectedNode },
                on: {
                  addPlan: _vm.handleAddPlan,
                  editPlan: _vm.handleEditPlan,
                  close: _vm.handleClose,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "can",
              rawName: "v-can",
              value: "beepiz-add-plans",
              expression: "'beepiz-add-plans'",
            },
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.hideCtm,
              expression: "hideCtm",
            },
          ],
          staticClass: "context-menu",
          class: { show: _vm.showCtm },
          style: _vm.contextMenuPosition,
          attrs: { id: "ctm" },
        },
        [
          _c("ul", [
            _c(
              "li",
              {
                class: { disabled: !_vm.rulesForAdd.plan },
                on: {
                  click: function ($event) {
                    return _vm.showModal("add", "plan")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-map fa-fw" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("plans.btns.addActions.plan")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: { disabled: !_vm.rulesForAdd.service },
                on: {
                  click: function ($event) {
                    return _vm.showModal("add", "service")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-folder fa-fw" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("plans.btns.addActions.service")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: { disabled: !_vm.rulesForAdd.floor },
                on: {
                  click: function ($event) {
                    return _vm.showModal("add", "floor")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-bars fa-fw" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("plans.btns.addActions.floor")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: { disabled: !_vm.rulesForAdd.building },
                on: {
                  click: function ($event) {
                    return _vm.showModal("add", "building")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-building fa-fw" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("plans.btns.addActions.building")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: { disabled: !_vm.rulesForAdd.group },
                on: {
                  click: function ($event) {
                    return _vm.showModal("add", "group")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-folder fa-fw" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("plans.btns.addActions.group")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: { disabled: !_vm.rulesForAdd.site },
                on: {
                  click: function ($event) {
                    return _vm.showModal("add", "site")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-globe fa-fw" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("plans.btns.addActions.site")) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }